import { Component, OnInit } from '@angular/core';

interface IPermission {
  icon: string;
  type: string;
  desc: string;
}

@Component({
  selector: 'app-access-description',
  templateUrl: './access-description.component.html',
  styleUrls: ['./access-description.component.scss'],
})
export class AccessDescriptionComponent implements OnInit {
  permissionDetails: IPermission[] = [
    {
      icon: 'circle circle--green',
      type: 'EDIT',
      desc: 'STAFF.FULL.DESC',
    },
    {
      icon: 'circle circle--yellow',
      type: 'VIEW',
      desc: 'STAFF.VIEW.DESC.NEW',
    },
    {
      icon: 'circle circle--red',
      type: 'HIDE',
      desc: 'STAFF.HIDDEN.DESC',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
